


























import { Component, Vue } from 'vue-property-decorator';
import { fetchHealthCheck } from '@/services/common';

interface HealthCheckResponse {
  code: number;
  message: string;
  data: any;
  duration?: number;
}

@Component
export default class HealthCheck extends Vue {
  private status: 'success' | 'error' | 'loading' = 'loading';
  private duration: number = 0;
  private isOnline: boolean = navigator.onLine;
  private checkInterval: number | null = null;

  get tooltipContent(): string {
    const statusText = !this.isOnline ? '网络离线' : this.status === 'success' ? '正常' : this.status === 'error' ? '异常' : '检查中';
    const durationText = this.isOnline && this.status !== 'error' ? `(${this.duration}ms)` : '';
    return `服务状态: ${statusText} ${durationText}`;
  }

  mounted() {
    // 添加网络状态监听
    window.addEventListener('online', this.handleOnline);
    window.addEventListener('offline', this.handleOffline);

    // 初始检查
    this.checkHealth();

    // 每30秒检查一次
    this.checkInterval = window.setInterval(this.checkHealth, 30000);
  }

  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('online', this.handleOnline);
    window.removeEventListener('offline', this.handleOffline);

    // 清除定时器
    if (this.checkInterval !== null) {
      clearInterval(this.checkInterval);
    }
  }

  private handleOnline() {
    this.isOnline = true;
  }

  private handleOffline() {
    this.isOnline = false;
  }

  private async checkHealth() {
    if (!this.isOnline) {
      this.status = 'error';
      return;
    }

    try {
      const result = (await fetchHealthCheck()) as HealthCheckResponse;
      this.status = result.code === 0 || result.code === 200 ? 'success' : 'error';
      this.duration = result.duration || 0;
    } catch (error) {
      this.status = 'error';
    }
  }
}
